import { useEffect, useRef, useState } from "react";
import { AddNewCourse } from "./addNewCourse";
import { LessonContentComp } from "./lessonContentComp";
import { CreateLessonComp } from "./createLessonContent";
import { LessonInputTitle, LessonTitle } from "../molecule/lessonTitle";
import { deleteAPI, getAPI, postAPI, updateAPI, postAPImedia, ip } from "../api/api";
import { set } from "date-fns";



export function LessonComp({ allSkills, customMessage,changeIndex, lessonData = {}, onClick, navigation, typeInput, remove, animationState, key, handleLoading, loading, message, setLoading, skills, loadSkills, setSkills }) {
    const [lessoncontent, setLessonContent] = useState([])
    const [changeTitle, setChangeTitle] = useState(false)
    const lessonComp = useRef({})
    const [replaceContainer, setReplaceContainer] = useState(false)
    const [transition, setTransition] = useState(false)
    const [number, setNum] = useState(0)
    var currentlyLoading = useRef(true);

    useEffect(() => {
        if (navigation) return;

        if (!lessonData?.active) {
            setLessonContent([]);
            return;
        }

        if (!lessonData?.id_lessons) {
            setLessonContent([]);
            return;
        }

        let isCancelled = false;
        const fetchModules = async () => {
            setLessonContent([]);
            const query = `api/courses/lessons/${lessonData.id_lessons}/modules`;
            const modules = await getAPI(query);
            if (!isCancelled) {
                setLessonContent(modules.data || []);
            }
        };

        fetchModules();

        return () => {
            isCancelled = true;
        };
    }, [navigation, lessonData?.active, lessonData?.id_lessons]);
    const addCourse = (event) => {

        event.stopPropagation()
        setNum(number + 1)
        setLessonContent([...lessoncontent, number])
    }
    const removeContent = async (event, index) => {
        if (handleLoading()) return;
        event.stopPropagation()
        const newContent = [...lessoncontent]
        const query = "api/courses/lessons/modules/delete"
        const body = { "id_modules": lessoncontent[index]["id_modules"] }
        newContent.splice(index, 1)
        setLessonContent(newContent)
        await deleteAPI(query, body)
    }


    const redoTitle = async () => {
        if (handleLoading()) return;
        if (changeTitle) {
            const updatedLessonData = { ...lessonData, title: lessonData.title };
            const query = "api/courses/lessons/update"
            const body = {
                "id_lessons": updatedLessonData.id_lessons,
                "title": updatedLessonData.title,
                "id_course": updatedLessonData.id_course
            }
            await updateAPI(query, body)
        }
        setChangeTitle(!changeTitle)

    }
    function handleOpenLesson(event) {
        if (handleLoading()) return;
        event.stopPropagation()
        scrollToItem(key)
        if (changeTitle) {
            redoTitle();
        }
        onClick(event)
    }
    function removeItem(e) {
        if (handleLoading()) return;
        setTransition(`${(lessonComp.current.clientHeight + 14) / 16}rem`)
        setTransition("0rem")
        remove(e)

    }
    const updateContent = async (value, index) => {
        const copyLessonContent = [...lessoncontent];
        copyLessonContent[index] = value;
        setLessonContent(copyLessonContent);
        const query = "api/courses/lessons/modules/update";
        const update = await updateAPI(query, value);
        if (update === "ok") {
            console.log("Module updated:", value);
        }
    };
    const handleCreateModule = async (event, module_type, index) => {
        if (handleLoading()) return;
        event.stopPropagation()
        const query = "api/courses/lessons/modules/create"
        const copyModule = {}
        copyModule["module_type"] = module_type
        copyModule["id_lessons"] = lessonData.id_lessons
        const created = await postAPI(query, copyModule)
        if (!created || created.status !== "ok") {
            console.error("Module creatie mislukt", created);
            return;
        }
        copyModule["id_lessons"] = lessonData.id_lessons
        copyModule.id_modules = created.data
        copyModule.indexed_order = index + 1
        copyModule.module_content = {}
        copyModule.weight = 1
        copyModule.time = 0
        const copyLessonContent = [...lessoncontent]
        copyLessonContent.splice(index, 1, copyModule)

        setLessonContent([...copyLessonContent])

        return copyModule

    }
    const isAcceptedImage = (file) => {
        if (!file) return false;
        if (file.type && /image\/(png|jpeg)/i.test(file.type)) {
            return true;
        }
        return /\.(png|jpe?g)$/i.test(file.name || "");
    };
    const handleDroppedImages = async (files, index) => {
        if (!Array.isArray(files) || files.length === 0) {
            return;
        }
        if (handleLoading()) return;

        const acceptedFiles = files.filter(isAcceptedImage);
        if (acceptedFiles.length === 0) {
            return;
        }

        const stopEvent = { stopPropagation: () => { } };

        let createdModule;
        try {
            setLoading?.(true);
            const uploadedUrls = [];
            for (const file of acceptedFiles) {
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const response = await postAPImedia("api/media/add-media", formData);
                    const mediaUrl = response?.data?.url;
                    const isOk = response?.status === "ok" || response?.success === true;
                    if (mediaUrl && (isOk || !response?.status)) {
                        uploadedUrls.push(`${ip}/api/media/${mediaUrl}`);
                    }
                } catch (error) {
                    console.error("Image upload failed:", error);
                }
            }

            if (uploadedUrls.length === 0) {
                return;
            }

            createdModule = await handleCreateModule(stopEvent, 2, index, { bypassLoadingGuard: true });
            if (!createdModule?.id_modules) {
                return;
            }

            const editorData = {
                time: Date.now(),
                blocks: uploadedUrls.map((url, idx) => ({
                    id: `auto-image-${Date.now()}-${idx}-${Math.random().toString(36).slice(2, 8)}`,
                    type: "image",
                    data: {
                        type: 2,
                        image: { url }
                    }
                })),
                version: "2.30.8"
            };

            const payload = {
                id_lessons: lessonData.id_lessons,
                id_modules: createdModule.id_modules,
                module_type: 2,
                indexed_order: createdModule.indexed_order,
                time: createdModule.time ?? 0,
                weight: createdModule.weight ?? 1,
                module_content: { text_content: editorData }
            };

            const updateResponse = await updateAPI("api/courses/lessons/modules/update", payload);
            if (updateResponse?.status !== "ok") {
                console.error("Failed to auto-create text module content", updateResponse);
                try {
                    await deleteAPI("api/courses/lessons/modules/delete", { id_modules: createdModule.id_modules });
                    setLessonContent(prev => prev.filter(mod => mod?.id_modules !== createdModule.id_modules));
                } catch (error) {
                    console.error("Failed to rollback module after update error:", error);
                }
                return;
            }

            createdModule.module_content = editorData;
            createdModule.module_type = 2;

            setLessonContent(prev => {
                const cloned = [...prev];
                const moduleIndex = cloned.findIndex(mod => mod?.id_modules === createdModule.id_modules);
                const targetIndex = moduleIndex !== -1 ? moduleIndex : index;
                const targetModule = cloned[targetIndex] || {};
                cloned[targetIndex] = {
                    ...targetModule,
                    ...createdModule,
                    module_type: 2,
                    module_content: editorData
                };
                return cloned;
            });
        } finally {
            setLoading?.(false);
        }
    }
    const itemRefs = useRef({});

    const scrollToItem = (key) => {

        lessonComp.current[key]?.scrollIntoView({
            behavior: 'smooth', block: 'start', // you can also try 'nearest' or 'center' if 'start' jumps too much
            inline: 'nearest'
        });
    };
    const redOrderModule = async (index, lesson, direction) => {

        if (handleLoading()) return;

        const query = "api/courses/lessons/modules/update-order"
        const body = {
            "id_lessons": lessonData.id_lessons,
            "id_lesson": lessonData.id_lessons,
            "id_modules": lesson.id_modules,
            "direction": direction,
            order: direction == "down" ? index + 1 + 1 : index
        }
        const reorder = await updateAPI(query, body)
        if (reorder.status == "ok") {
            re_order(index, direction)
        }

    }

    function re_order(index, direction) {
        if (direction == "up") {
            re_order_up(index)
            return
        }
        re_order_down(index)

    }

  
    function re_order_up(index) {

        const copyLessonContent = [...lessoncontent]
        const copyLessonContent2 = [...lessoncontent]

        const order1 = copyLessonContent[index - 1]
        const order2 = copyLessonContent[index]

        copyLessonContent2[index - 1] = order2
        copyLessonContent2[index] = order1

        setLessonContent(copyLessonContent2)
    }

    function re_order_down(index) {
        const copyLessonContent = [...lessoncontent]
        const copyLessonContent2 = [...lessoncontent]

        const order1 = copyLessonContent[index]
        const order2 = copyLessonContent[index + 1]

        copyLessonContent2[index + 1] = order1
        copyLessonContent2[index] = order2

        setLessonContent(copyLessonContent2)
    }


    const generateAiContent = async ( aiSettings, module_type, index) => {

        const moduleTypeMap = {
            quiz: 1,
            text: 2,
            video: 3,
            1: 1,
            2: 2,
            3: 3
        };

        const module_type1 = moduleTypeMap[module_type];
        const query = "api/courses/lessons/modules/generate-content";
        const body = {
            lesson_title: lessonData.title,
            id_lessons: lessonData.id_lessons,
            id_course: lessonData.id_course,
            module_type: module_type1,
            aiSettings: aiSettings
        }

        const res = await postAPI(query, body);

        if (res.status === "ok") {
            insertGeneratedContent(module_type1, res.data, index)
        }
            
    }
    const insertGeneratedContent = async (module_type, module, index) => {

         const moduleTypeMap = {
            quiz: "quiz_content",
            text: "text_content",
            video: "video_content",
            1: "quiz_content",
            2: "text_content",
            3: "video_content"
        };
        const copyContent = [...lessoncontent]
        const contentType = moduleTypeMap[module_type]
        const newModule = { ...module }
        newModule.indexed_order = index + 1
        newModule.module_content = newModule.module_content[contentType]

        copyContent.splice(index, 1, newModule)
        setLessonContent(copyContent)
    }
    
    
    return (
        replaceContainer ? <div key={key} className={`replace-container`} style={{ height: transition, backgroundColor: "white" }} ></div> :

            <div data-testid={"lesson-comp-1"} key={key} ref={(el) => lessonComp.current[key] = (el)} onClick={(event) => handleOpenLesson(event)} className={`${animationState == "remove" ? "lesson-removing" : ""} ${animationState == "create" ? "lesson-creating" : ""} vertical space-between small-standard-padding heavy-border standard-rounded lesson-comp ${lessonData.active && 'primary-background-50'} `} style={{ width: "unset", backgroundColor: replaceContainer && "white", borderColor:lessonData.update_lesson_index == true &&"var(--primary-500)", transition:"0.3s", transform:lessonData.update_lesson_index == true &&"scale(1.02)"}}>

                {changeTitle ?
                    <LessonInputTitle
                        typeInput={(text) => {
                            lessonData.title = text;
                            typeInput(text);
                        }}
                        title={lessonData.title}
                        placeholder={lessonData.title}
                        onClick={redoTitle} /> :
                    <LessonTitle
                        changeIndex={changeIndex}
                        onClick={redoTitle}
                        remove={removeItem}
                        navigation={!navigation}
                        lessonInformation={{ title: lessonData.title, duration: lessonData.duration }}
                        message={message}
                    />
                }


                {(lessonData.active && !navigation) &&
                    <>
                        {

                            lessoncontent?.map(((lesson, index) => {
                                return (
                                    <LessonContentComp

                                        moveUp={index === 0 ? null : () => redOrderModule(index, lesson, "up")}
                                        moveDown={index === lessoncontent.length - 1 ? null : () => redOrderModule(index, lesson, 'down')}
                                        scrollToItem={scrollToItem}
                                        index={index}
                                        itemRef={itemRefs}
                                        key={lesson.indexed_order}
                                        remove={(event) => removeContent(event, index)}
                                        inputs={
                                            <>

                                                <CreateLessonComp
                                                    customMessage={customMessage}
                                                    lessonID={lessonData.id_lessons}
                                                    id_module={lesson.id_modules}
                                                    create={(event, value) => handleCreateModule(event, value, index)}
                                                    content={lesson.module_content}
                                                    updateContent={(data) => updateContent(data, index)}
                                                    data={lesson}
                                                    type={lesson.module_type || 0}
                                                    title={lessonData.title}
                                                    loading={loading}
                                                    setLoading={setLoading}
                                                    skills={skills}
                                                    loadSkills={loadSkills}
                                                    allSkills={allSkills}
                                                    setSkills={setSkills}
                                                    onImageDrop={(files) => handleDroppedImages(files, index)}
                                                    generateAiContent={async (aiSettings, module_type) => await generateAiContent(aiSettings, module_type, index)}  
                                                />
                                            </>
                                        }

                                        currentlyLoading={currentlyLoading.current}
                                    />
                                )
                            }))}
                        <AddNewCourse
                            onClick={addCourse}
                        />
                    </>
                }
            </div>
    )
}
